import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Image = styled.img<{size: number}>`
  width: ${({size}) => `${size}px`};
  height: ${({size}) => `${size}px`};
  border-radius: ${({size}) => `${size / 2}px`};
`;
